// extracted by mini-css-extract-plugin
var _1 = "tabs---active---ZxzpF";
var _2 = "tabs---header---IBrhQ";
var _3 = "tabs---tabMenu---anFxs";
var _4 = "tabs---tabPanel---YuBxh";
var _5 = "tabs---tabs---rXAa3";
export { _1 as "active", _2 as "header", _3 as "tabMenu", _4 as "tabPanel", _5 as "tabs" }
